import { render, staticRenderFns } from "./m-solution-detail.vue?vue&type=template&id=69f879b5"
import script from "./m-solution-detail.vue?vue&type=script&lang=js"
export * from "./m-solution-detail.vue?vue&type=script&lang=js"
import style0 from "./m-solution-detail.vue?vue&type=style&index=0&id=69f879b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports